export enum GoCardlessAccessScopeEnum {
  BALANCES = 'balances',
  DETAILS = 'details',
  TRANSACTIONS = 'transactions',
}